import { createTheme } from '@mui/material/styles';

export default createTheme({
  palette: {
    mode: 'dark', primary: { main: '#efab57', contrastText: '#17130e' }, secondary: { main: '#b9c4b6' },
    background: { default: '#101210', paper: '#191d19' }, text: { primary: '#f1f2eb', secondary: '#a6afa4' },
    divider: '#343b32', error: { main: '#ef8581' }, warning: { main: '#e6b968' },
  },
  typography: { fontFamily: '"Segoe UI", sans-serif', h3: { fontSize: '2rem', fontWeight: 750 }, h4: { fontSize: '1.8rem', fontWeight: 750 }, button: { textTransform: 'none', fontWeight: 600 } },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiTableCell: { styleOverrides: { head: { backgroundColor: '#232920', color: '#c9d0c4', fontWeight: 700, whiteSpace: 'nowrap' }, body: { fontSize: '0.875rem' } } },
    MuiContainer: { styleOverrides: { root: { paddingTop: 36, paddingBottom: 48 } } },
    MuiDialog: { styleOverrides: { paper: { backgroundImage: 'none' } } },
  },
});
